import * as types from "@/store/types";
import { UnauthenticatedService } from "../abstract/base.service";
import CurrentData from "@/models/auth/current.data";
import { AuthenticateModel } from "@/server/app.commands";

class AuthService extends UnauthenticatedService {
  Login(model: AuthenticateModel): Promise<string> {
    return this.Post<string>(`${this.baseUrl}auth/login`, model);
  }

  StartRecover(url: string, username: string): Promise<void> {
    return this.Post(`${this.baseUrl}auth/tryrecover`, { Url: url, Username: username });
  }

  Recover(token: string, pwd: string): Promise<void> {
    return this.Post(`${this.baseUrl}auth/recover`, {
      Token: token,
      Password: pwd
    });
  }

  Logout(): void {
    this.ClearToken();
  }

  Load(): Promise<CurrentData> {
    return this.Get<CurrentData>(`${this.baseUrl}api/current`, {
      headers: { Authorization: `Bearer ${this.GetToken()}` }
    });
  }

  GetToken(): string | null {
    return window.localStorage.getItem(types.GLOBAL_USER_TOKEN);
  }

  SetToken(token: string): void {
    window.localStorage.setItem(types.GLOBAL_USER_TOKEN, token);
  }

  ClearToken(): void {
    window.localStorage.removeItem(types.GLOBAL_USER_TOKEN);
  }
}

export default AuthService;
